import { Logger } from '@vp/ubik-logging'
import { ProductCallout, CalloutType } from '../../components/AutoGenerate/types/AutomatedExperience'
import { SupportedMerchandisingTagType } from '../../types/Callout'
import { CalloutDataType, AllAvailableTags } from '../productTileCollection/productTileCollection'
import { resolveCalloutSkin, resolveCalloutEmphasis } from './calloutSkinResolver'

type CalloutData = {
  isOutOfStock?: boolean
  outOfStockText: string
  callout?: ProductCallout | ProductCallout[] | CalloutDataType
  allAvailableTags: AllAvailableTags | undefined
  logger: Logger | undefined
  tileId: string | undefined
}

export const buildProductCallout = (calloutData: CalloutData): ProductCallout | ProductCallout[] => {
  const { callout, isOutOfStock, allAvailableTags, outOfStockText, logger, tileId } = calloutData

  if (isOutOfStock && isOutOfStock === true && outOfStockText !== '') {
    return {
      value: outOfStockText!,
      skin: resolveCalloutSkin(CalloutType.OUT_OF_STOCK),
      emphasis: resolveCalloutEmphasis(CalloutType.OUT_OF_STOCK),
    }
  }
  if (Array.isArray(callout as ProductCallout[])) {
    const transformedCallouts = (callout as ProductCallout[]).map((c: ProductCallout) => {
      const tagType =
        c.tagType && c.tagType in SupportedMerchandisingTagType
          ? SupportedMerchandisingTagType[c.tagType as keyof typeof SupportedMerchandisingTagType]
          : undefined

      return {
        ...c,
        skin: resolveCalloutSkin(c.type, tagType),
        emphasis: resolveCalloutEmphasis(c.type),
      }
    })

    return transformedCallouts as ProductCallout[]
  } else {
    if (!allAvailableTags) {
      logger?.warn('Missing allAvailableTags in product tile', { tileId: tileId })
    }
    const defaultCallout = allAvailableTags?.default
    const calloutObj = callout as CalloutDataType

    return {
      value: defaultCallout?.value || calloutObj?.text?.value,
      skin: defaultCallout?.skin || calloutObj?.skin,
      variant: defaultCallout?.variant || calloutObj?.variant,
      tagType: defaultCallout?.id || calloutObj?.nonLocalizedValue,
    } as ProductCallout
  }
}
